import { TdsFooterLite, BasicLayout } from '@tencent/tds-ui';
import { useLocalStorageState } from 'ahooks';
import { Carousel, Modal, Spin, Typography } from 'antd';
import axios from 'axios';
import classnames from 'classnames';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import NoticeInfoIcon from '@/assets/images/icons/notice-info.react.svg?react';
import BuglyIcon from '@/assets/images/public/bugly2.0.react.svg?react';
import { useAppConfig } from '@/config/context';
import { getUserId, isInternal } from '@/infrastructure/auth';
import { pushHistory } from '@/infrastructure/history';
import { logger } from '@/infrastructure/logger';
import { getPlatform, getProductId } from '@/infrastructure/product-info';
import { CUSTOM_ACTIONS } from '@/infrastructure/reporter/datong/constant';
import { reportClick } from '@/infrastructure/reporter/datong/report';
import { Banner } from '@/presentation/components/banner';
import { useAuthContext } from '@/presentation/hooks';
import { Content } from '@/presentation/layouts/content';
import { TopMenu } from '@/presentation/layouts/header';
import { AppList } from '@/presentation/layouts/header/app-list';
import { Tools } from '@/presentation/layouts/tools';
import {
  getEntriesRoutes,
  getOverlaysRoutes,
} from '@/presentation/routes/routes';
import { stores, useStores } from '@/presentation/store';
import style from './index.module.scss';
interface NoticeInfoType {
  _id?: string,
  _mtime?: string,
  mainTitle?: string,
  functionTitle?: string,
  desc?: string,
  detailLink?: string,
  imageUrl?: string[],
  expireTime?: string,
  hasClosed?: boolean,
  whiteList?: string[],
  appVersion?: string[],
  isLinkNeedModify?: boolean,
}

export const AppLayout = observer(() => {
  const { loaded, productId, hasProduct } = stores.ProductStore;
  const { collapsed, setCollapsed, layoutLoading, loadingMessage, pgid } = useStores().LayoutStore;
  const { authInfo } = useAuthContext();
  const history = useHistory();
  const location = useLocation();
  const config = useAppConfig();
  const { Paragraph } = Typography;
  const [currPlatform, setCurrPlatform] = useState<string>();
  const [noticeInfo, setNoticeInfo] = useLocalStorageState < Record<string, NoticeInfoType>>('notice-info-storage', { listenStorageChange: true });
  const [latestNoticeInfo, setLatestNoticeInfo] = useLocalStorageState <Record<string, string>>('latest-noticeInfo-storage', { listenStorageChange: true });
  const handlePath = (path: string) => {
    pushHistory(history, path);
  };
  const isConfig = location.pathname.includes('/config-manage');
  const liteModeRoutes = ['/workbench/apps', '/user/profile', '/config-manage'];
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setNoticeInfo({
      ...noticeInfo,
      [currPlatform as string]: {
        ...noticeInfo?.[currPlatform as string],
        hasClosed: true,
      },
    });
    setIsModalOpen(false);
    reportClick(pgid, CUSTOM_ACTIONS.noticeModalView, {
      from: pgid,
    });
  };

  const viewDetail = () => {
    let modifiedUrl: string;
    if (noticeInfo?.[currPlatform as string]?.isLinkNeedModify) { // 替换域名和productId
      try {
        const parsedUrl = new URL(noticeInfo?.[currPlatform as string]?.detailLink || '');
        parsedUrl.hostname = window.location.hostname;
        const params = new URLSearchParams(parsedUrl.search);
        if (params.has('productId')) {
          const productId = getProductId();
          params.set('productId', productId);
          parsedUrl.search = params.toString();
        }
        modifiedUrl = parsedUrl.toString();
      } catch (error) {
        logger.error('无效的 URL', error);
      }
    } else {
      modifiedUrl = noticeInfo?.[currPlatform as string]?.detailLink as string;
    }
    setIsModalOpen(false);
    setTimeout(() => window.open(modifiedUrl, '_blank'), 100);
    setNoticeInfo({
      ...noticeInfo,
      [currPlatform as string]: {
        ...noticeInfo?.[currPlatform as string],
        hasClosed: true,
      },
    });
    reportClick(pgid, CUSTOM_ACTIONS.noticeModalView, {
      from: pgid,
    });
  };

  const noticeInfoQuery = async () => {
    const noticeUrlObj = new URL(config.noticeRequestURL);
    const searchParams = new URLSearchParams(noticeUrlObj.search);
    const filter = searchParams.get('filter');// 获取注入url的filter参数

    const currTime =  moment().unix();
    searchParams.set('filter', `expireTime>${currTime}&${filter}`);// 更新filter参数包含过期时间的筛选

    noticeUrlObj.search = searchParams.toString();
    const noticeURL = noticeUrlObj.toString();

    try {
      const res = await axios.get(
        noticeURL,
        { withCredentials: true },
      );
      return res.data;
    } catch {
      return null;
    }
  };

  const load = async () => {
    if (liteModeRoutes.includes(location.pathname)) { // 用户没有进到具体的产品页直接不请求
      return;
    }
    const originNoticeInfo = await noticeInfoQuery();

    if (originNoticeInfo.data?.length === 0) {
      return;
    }
    // eslint-disable-next-line max-len
    const lastModifyItem = originNoticeInfo?.data?.filter((info: any) => info?.platform?.includes(getPlatform()))?.[0];

    const whiteList = lastModifyItem?.whiteListForOA;
    if (
      !lastModifyItem// 管理台没有设置弹窗内容
      || (whiteList?.length !== 0
        && !whiteList?.includes(getUserId())) // 用户不在白名单
    ) {
      return;
    }

    if (
      (!noticeInfo?.[currPlatform as string]
        && (lastModifyItem?._id !== latestNoticeInfo?._id
          || lastModifyItem?._mtime !== latestNoticeInfo?._mtime)) // 没有历史通知信息且最新通知用户未看过
      || (noticeInfo?.[currPlatform as string]
        && (((lastModifyItem?._id !== noticeInfo?.[currPlatform as string]?._id
          || lastModifyItem?._mtime
            !== noticeInfo?.[currPlatform as string]?._mtime) && (lastModifyItem?._id !== latestNoticeInfo?._id
              || lastModifyItem?._mtime !== latestNoticeInfo?._mtime))
          || !noticeInfo?.[currPlatform as string]?.hasClosed)
      )
      // 拉取到的最新通知信息和存储的通知信息对比 须满足「{id不同或者同一id但被修改过}且{该消息在其他平台未被用户看到过}」或者「相同的弹窗但之前用户没有关闭」
    ) {
      setIsModalOpen(true);
      try {
        setNoticeInfo({
          ...noticeInfo,
          [currPlatform as string]: lastModifyItem,
        });
        setLatestNoticeInfo({ ...latestNoticeInfo, _id: lastModifyItem?._id, _mtime: lastModifyItem?._mtime });
      } catch {
        logger.error();
      }
    }
  };

  useEffect(() => {
    logger.info(
      'AppLayout|render',
      productId,
      location.pathname,
      loaded,
      authInfo,
    );
    // 无产品选中，跳首页 登录了情况才跳
    if (loaded && !productId && !liteModeRoutes.includes(location.pathname)) {
      pushHistory(history, '/index/main');
    }
  }, [loaded, productId]);

  useEffect(() => {
    if (isInternal() && authInfo?.isLoggedIn) {
      stores.ProductStore.initForInternal();
    }
  }, []);

  useEffect(() => {
    setCurrPlatform(getPlatform());
  }, [getPlatform()]);

  useEffect(() => {
    if (authInfo?.isLoggedIn) {
      load();
    }
  }, [currPlatform, location.pathname]);

  // 没登录不render
  if (!authInfo?.isLoggedIn) {
    return null;
  }
  return (
    <Spin
      spinning={layoutLoading}
      tip={loadingMessage}
      className={style.loading}
    >
      <BasicLayout
        liteMode={!hasProduct}
        showBreadcrumb={hasProduct}
        className={classnames({
          [style.app]: true,
          [style.config]: isConfig,
        })}
        leftMenuRoutes={{ routes: getEntriesRoutes() }}
        overlayMenuRoutes={{ routes: getOverlaysRoutes() }}
        appSelector={<AppList />}
        topMenu={<TopMenu />}
        liteModeRoutes={liteModeRoutes}
        logo={
          <Link to={'/index/main'}>
            <BuglyIcon />
          </Link>
        }
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        handlePath={handlePath}
        title={'Bugly'}
        renderBanner={(showBanner, setShowBanner) => (
            <Banner
              showBanner={showBanner}
              setShowBanner={setShowBanner}
              liteModeRoutes={liteModeRoutes}
            />
        )}
      >
        <div className={classnames(style.containerLayout, 'content-layout')}>
          <Content />
          <TdsFooterLite isTdsQQ={isInternal()} />
          <Tools />
        </div>
      </BasicLayout>
      <Modal
        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className={style.modal}
        footer={null}
        maskClosable={false}
        keyboard={false}
        centered={true}
      >
        <div className={style.modalBox}>
          <div className={style.leftBox}>
            <div className={style.mainTitle}>
              <NoticeInfoIcon />
              <span>
                {noticeInfo?.[currPlatform as string]?.mainTitle}
              </span>
            </div>
            <div
              className={style.functionTitle}
            >
              {noticeInfo?.[currPlatform as string]?.functionTitle}
            </div>
            <Paragraph
              className={style.desc}
              ellipsis={{ rows: 3 } }
            >
              <div dangerouslySetInnerHTML={{ __html: noticeInfo?.[currPlatform as string]?.desc || '' }} />
            </Paragraph>
            <div
              className={style.viewDetailBox}
              onClick={viewDetail}>
              <span className={style.viewDetailText}>查看详情</span>
            </div>
          </div>
          <div className={style.rightSlide}>
            <Carousel autoplay dots={true}>
              {noticeInfo?.[currPlatform as string]?.imageUrl?.map?.((url, idx) => <img src={url || ''} key={idx}></img>)}
            </Carousel>
          </div>
        </div>
      </Modal>
    </Spin>
  );
});
